import Money from "../../../../../Atoms/Money";
import { Text } from "../../../../../Atoms/Typography";
import styles from "../CheckoutSummary.module.css";

type OrderLineItemProps = {
  quantity?: number;
  label: string;
  unitAmount: number;
  currencyCode: string;
  hideFree?: boolean;
};

export default function OrderLineItem({
  quantity,
  label,
  unitAmount,
  currencyCode,
  hideFree,
}: OrderLineItemProps) {
  const amount = (quantity ?? 1) * unitAmount;

  return (
    <div className={styles.GuestCosts}>
      {
        <Text size="small">
          {!!quantity && <>{quantity} &times; </>}
          {label}
        </Text>
      }
      <Text size="small">
        {amount === 0 ? (
          !hideFree && (
            <div style={{ fontWeight: 700, fontSize: 11.95, color: "#4caf50" }}>
              FREE
            </div>
          )
        ) : (
          <Money amount={amount} currency={currencyCode} />
        )}
      </Text>
    </div>
  );
}
